/**
 * @fileoverview Skeleton mirroring a task card 1:1 (plan Parte 6.1). `twoColumns`
 * reflects deliverable/self-assessment (project + lesson) vs. final (project only).
 */

import { Box, Card, Divider, Flex, Group, Skeleton, Stack } from '@mantine/core'
import { CARD_ACTION_WIDTH, SKELETON } from '../../constants'

interface StudentTaskCardSkeletonProps {
  twoColumns?: boolean
  withDueDate?: boolean
}

const { card } = SKELETON

const Column = () => (
  <Stack spacing={4} style={{ flex: 1, minWidth: 0 }}>
    <Skeleton height={card.columnLabel.height} width={card.columnLabel.width} />
    <Skeleton height={card.columnValue.height} width={card.columnValue.width} />
  </Stack>
)

export function StudentTaskCardSkeleton({
  twoColumns = true,
  withDueDate = false,
}: StudentTaskCardSkeletonProps) {
  return (
    <Card withBorder radius="md" padding="md">
      <Stack spacing="md">
        <Group position="apart" noWrap>
          <Group spacing="xs" noWrap>
            <Skeleton height={card.typeLabel.height} width={card.typeLabel.width} />
            <Skeleton height={card.badge.height} width={card.badge.width} radius="sm" />
          </Group>
          {withDueDate && <Skeleton height={card.dueDate.height} width={card.dueDate.width} />}
        </Group>

        <Divider />

        <Flex justify="space-between" align="center" gap="md" wrap="wrap">
          <Flex gap="md" style={{ flex: 1, minWidth: 0 }}>
            <Column />
            {twoColumns && <Column />}
          </Flex>
          <Box style={{ flexShrink: 0 }}>
            <Skeleton height={card.action.height} width={CARD_ACTION_WIDTH} radius="sm" />
          </Box>
        </Flex>
      </Stack>
    </Card>
  )
}
